(function () {
    'use strict';

    if (window.__BACKCARD_TABS_BOUND__) return;
    window.__BACKCARD_TABS_BOUND__ = true;

    var BACKCARD_DRAWER = '.backcard_personalise-drawer';
    var TERMS_MSG = 'Please agree to the Terms & Conditions.';

    function switchBackcardTab(root, side) {
        if (!root || !side) return;
        root.querySelectorAll('.backcard_main-tab').forEach(function (tab) {
            tab.classList.toggle('active', tab.getAttribute('data-side') === side);
        });
        root.querySelectorAll('.backcard_tab-panel').forEach(function (panel) {
            panel.classList.toggle('active', panel.getAttribute('data-side') === side);
        });
    }
    window.switchBackcardTab = switchBackcardTab;

    document.addEventListener('click', function (e) {
        var tab = e.target.closest('.backcard_main-tab');
        if (!tab) return;
        var root = tab.closest(BACKCARD_DRAWER);
        if (!root) return;
        switchBackcardTab(root, tab.getAttribute('data-side'));
    });

    /* ---------------------------------------------------- terms helpers */

    function termsCheckbox(root) {
        return root.querySelector('.backcard_terms-checkbox input[type="checkbox"]');
    }

    function termsErrorEl(root) {
        var cb = termsCheckbox(root);
        if (!cb) return null;
        var wrap = cb.closest('.backcard_terms-wrapper');
        if (!wrap) return null;
        var err = wrap.querySelector('.backcard_checkbox-error');
        if (!err) {
            err = document.createElement('div');
            err.className = 'backcard_checkbox-error field-error';
            wrap.appendChild(err);
        }
        return err;
    }

    function clearTermsError(root) {
        var cb = termsCheckbox(root);
        var err = termsErrorEl(root);
        if (err) { err.classList.add('hidden'); err.textContent = ''; }
        if (cb) cb.classList.remove('is-invalid');
    }

    function validateTerms(root) {
        var cb = termsCheckbox(root);
        if (!cb) return true; // no checkbox rendered → nothing to enforce

        if (cb.checked) { clearTermsError(root); return true; }

        var err = termsErrorEl(root);
        if (err) { err.textContent = TERMS_MSG; err.classList.remove('hidden'); }
        cb.classList.add('is-invalid');

        var wrap = cb.closest('.backcard_terms-wrapper');
        if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
    }

    document.addEventListener('change', function (e) {
        var cb = e.target.closest(BACKCARD_DRAWER + ' input[type="checkbox"][data-side]');
        if (!cb || !cb.checked) return;
        var root = cb.closest(BACKCARD_DRAWER);
        if (root) clearTermsError(root);
    });

    /* ------------------------------------------------------------- close */

    function closeBackcardDrawer(root) {
        root.classList.remove('active');
        root.classList.add('hidden');
        document.body.classList.remove('personalise-drawer-open');
        var pop = root.closest('.pop-up');
        if (pop) pop.classList.remove('active');
    }

    function showFormError(root, msg) {
        var wrap = root.querySelector('.product-form__error-message-wrapper');
        var span = wrap ? wrap.querySelector('.product-form__error-message') : null;
        if (span) span.textContent = msg;
        if (wrap) wrap.hidden = false;
    }

    /* --------------------- "Add to cart" (no item_key) — own the submit */
    document.addEventListener('submit', function (e) {
        var form = e.target.closest(BACKCARD_DRAWER + ' form[data-type="add-to-cart-form"]');
        if (!form) return;

        e.preventDefault();
        e.stopPropagation();

        var root = form.closest(BACKCARD_DRAWER);
        if (!root) return;

        if (!validateTerms(root)) return;   // ← warning shown, submit blocked

        var submitBtn = form.querySelector('.backcard_product-form__submit');
        if (submitBtn) submitBtn.classList.add('loading');

        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
            .then(function (res) {
                return res.json().then(function (data) {
                    if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
                    return data;
                });
            })
            .then(function () {
                if (typeof window.refreshCartDrawer === 'function') return window.refreshCartDrawer();
            })
            .then(function () {
                closeBackcardDrawer(root);   // ← closes only after a confirmed success
            })
            .catch(function (err) {
                console.error('[backing-card] add to cart error:', err);
                showFormError(root, err.message || 'Something went wrong. Please try again.');
            })
            .finally(function () {
                if (submitBtn) submitBtn.classList.remove('loading');
            });
    }, true);

    /* --------------------- "Update" button (item_key present) */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest(BACKCARD_DRAWER + ' [data-id="builder-add-shared"]');
        if (!btn) return;

        var root = btn.closest(BACKCARD_DRAWER);
        if (!root) return;

        if (!validateTerms(root)) {
            e.preventDefault();
            e.stopPropagation();   // stops component-backing-card.js's own handler from running
        }
        // valid → falls through to whatever component-backing-card.js already binds to this button
    }, true); // capture:true so this runs before that handler
})();
